export default "<template>\n  <v-divider></v-divider>\n</template>\n";